import Vue from 'vue';
import commonVideo from '../../components/console-common/common-video.vue';
export default Vue.extend({
    name: 'noticeCenterMsg',
    components: {
        'el-common-video': commonVideo,
    },
    data: function () {
        return {
            businessData: [],
        };
    },
    created: function () {
        this.getNoticeList();
    },
    methods: {
        getNoticeList: function () {
            var _this = this;
            // 获取短信模板列表
            this.$request({
                method: 'post',
                url: '/proxy/api/msg/record/count',
            }).then(function (res) {
                if (!res)
                    return;
                if (res && !res.errorCode) {
                    _this.businessData = res.data;
                }
            });
        },
    },
});
